var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{staticClass:"audit-picker",attrs:{"position":"bottom","round":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('van-picker',{attrs:{"title":_vm.title,"show-toolbar":"","columns":_vm.columns},on:{"confirm":_vm.onConfirm,"cancel":function($event){_vm.visible = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }